import { useState } from "react";
import AdminShell from "@/components/admin/AdminShell";
import api, { formatApiError } from "@/lib/api";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function AdminSecurity() {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [conf, setConf] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setMsg("");
    if (next.length < 8) { setErr("New password must be at least 8 characters."); return; }
    if (next !== conf) { setErr("New password and confirmation don't match."); return; }
    setSaving(true);
    try {
      await api.post("/admin/auth/change-password", { current_password: cur, new_password: next });
      setMsg("Password updated. Use it on your next sign-in.");
      setCur(""); setNext(""); setConf("");
    } catch (e) { setErr(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <AdminShell subtitle="Security" title="Rotate your admin password">
      <div className="max-w-lg rounded-2xl bg-[#151737] border border-white/10 p-6">
        <div className="flex items-center gap-2 text-amber-300 mb-4"><KeyRound size={16} /> <div className="text-[11px] uppercase tracking-[0.25em] font-semibold">Change password</div></div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold">Current password</label>
            <input data-testid="admin-pw-current" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1 w-full px-4 py-3 rounded-xl bg-[#0F1020] border border-white/10 focus:border-amber-300 focus:outline-none text-slate-100" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold">New password</label>
            <input data-testid="admin-pw-new" type="password" required value={next} onChange={(e) => setNext(e.target.value)} className="mt-1 w-full px-4 py-3 rounded-xl bg-[#0F1020] border border-white/10 focus:border-amber-300 focus:outline-none text-slate-100" />
            <div className="text-[10px] text-slate-500 mt-1">Minimum 8 characters. Use a passphrase or password manager.</div>
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold">Confirm new password</label>
            <input data-testid="admin-pw-confirm" type="password" required value={conf} onChange={(e) => setConf(e.target.value)} className="mt-1 w-full px-4 py-3 rounded-xl bg-[#0F1020] border border-white/10 focus:border-amber-300 focus:outline-none text-slate-100" />
          </div>
          {err && <div data-testid="admin-pw-error" className="text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2">{err}</div>}
          {msg && <div data-testid="admin-pw-success" className="text-sm text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded-lg px-3 py-2 flex items-center gap-2"><CheckCircle2 size={14} /> {msg}</div>}
          <button data-testid="admin-pw-submit" disabled={saving} className="bg-gradient-to-r from-amber-400 to-rose-400 text-[#0F1020] px-6 py-2.5 rounded-full font-semibold hover:opacity-90 disabled:opacity-50">
            {saving ? "Saving…" : "Update password"}
          </button>
        </form>
      </div>
    </AdminShell>
  );
}
